import styled, { css } from 'styled-components';
import { widgetNavIsHidden } from '../../../helpers/widget';

interface ContainerProps {
  isFullscreen?: boolean;
  offset: number;
}

interface FullscreenProps {
  offset: number;
}

export default {
  Container: styled.div<ContainerProps>`
    position: absolute;
    left: 24px;
    top: 50%;
    margin-top: ${(props) => (widgetNavIsHidden(props) ? 0 - props.offset : 60 - props.offset)}px;
    transform: translateY(-50%);
    z-index: 3;

    @media (max-width: 1024px) {
      left: 8px;
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: 24px;
        left: unset;

        @media (max-width: 1024px) {
          right: 8px;
          left: unset;
        }
      `}
  `,

  Sign: styled.div`
    height: 17px;
    width: 17px;
    line-height: 11px;
  `,

  Fullscreen: styled.div<FullscreenProps>`
    position: absolute;
    bottom: ${(props) => props.offset + 24}px;
    left: 24px;
    z-index: 3;

    @media (max-width: 1024px) {
      left: 8px;
      bottom: ${(props) => props.offset + 8}px;
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: 24px;
        left: unset;

        @media (max-width: 1024px) {
          right: 8px;
          left: unset;
        }
      `}
  `,
};
